import { InfoCircleOutlined } from '@ant-design/icons';
import { useController } from '@framework/form/hooks/useController.ts';
import { RichTextButton } from '@framework/form/inputs/rich-text/menu/RichTextMenuButton.tsx';
import { Tooltip } from 'antd';

export interface IRichTextInfoInputButtonProps {
  name: string;
}

export function RichTextInfoInputButton(props: IRichTextInfoInputButtonProps) {
  const { name } = props;
  const { field } = useController(name);

  return (
    <Tooltip title="Imposta come icona informativa" placement="left">
      <RichTextButton
        icon={<InfoCircleOutlined />}
        title="Visualizza come icona informativa"
        isActive={field.value === 'info'}
        onClick={() => {
          field.onChange(field.value === 'info' ? 'text' : 'info');
          field.onBlur();
        }}
      />
    </Tooltip>
  );
}
